import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useProfile } from '../Components/Hooks/UserHooks.js';

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import PageTitle from "../Components/Common/PageTitle";

const Index = () => {
    const { loading } = useProfile();

    if (loading) {
        return <div>Loading...</div>; // Or your loading component
    }

    return (
        <React.Fragment>
            <PageTitle title="Friel Buildings" />
            <Routes>
                {/* Public Routes */}
                {publicRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                    />
                ))}

                {/* Protected Routes */}
                {authProtectedRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={
                            <AuthProtected>
                                <VerticalLayout>
                                    {route.component}
                                </VerticalLayout>
                            </AuthProtected>
                        }
                    />
                ))}

                {/* Catch all route */}
                <Route
                    path="*"
                    element={<Navigate to="/login" replace />}
                />
            </Routes>
        </React.Fragment>
    );
};

export default Index;
